import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "d-flex align-items-center position-relative my-1" }
const _hoisted_5 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "btn btn-primary ms-2",
  style: {"width":"auto"},
  disabled: ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Search", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "card mt-5" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = {
  key: 0,
  class: "my-10"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle text-dark" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Data hasil pencarian akan muncul disini. ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "w-100"
}
const _hoisted_18 = {
  key: 0,
  class: "my-5 bg-success",
  style: {"display":"flex"}
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { style: {"position":"absolute","top":"0","bottom":"0","left":"0","right":"0","margin":"auto","margin-top":"2rem","text-align":"center"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border text-primary mx-auto",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
  ])
], -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 0,
  class: "mt-5 w-100"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Ditemukan ")
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" untuk pencarian ")
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "col-md-12" }
const _hoisted_28 = { class: "row mt-5 px-9" }
const _hoisted_29 = { class: "col-md-9" }
const _hoisted_30 = { class: "card-title" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "d-flex card-title" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-calendar ms-auto me-1 fa-1x" }, null, -1)
const _hoisted_34 = { class: "h6 fw-normal" }
const _hoisted_35 = { class: "d-flex ms-9" }
const _hoisted_36 = {
  key: 0,
  class: "bi bi-newspaper me-1 fa-lg"
}
const _hoisted_37 = {
  key: 1,
  class: "bi bi-display me-1 fa-lg text-danger"
}
const _hoisted_38 = {
  key: 2,
  class: "bi bi-globe me-1 fa-lg text-success"
}
const _hoisted_39 = { class: "me-5" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-person-fill fa-lg me-1" }, null, -1)
const _hoisted_41 = { class: "me-auto" }
const _hoisted_42 = {
  class: "card-body",
  style: {"text-align":"justify"}
}
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = ["onClick"]
const _hoisted_46 = { key: 1 }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { class: "ms-auto me-9 mb-2" }
const _hoisted_50 = ["href"]
const _hoisted_51 = { class: "row" }
const _hoisted_52 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_53 = {
  class: "dataTables_length",
  id: "kt_customers_table_length"
}
const _hoisted_54 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_55 = /*#__PURE__*/_createElementVNode("option", { value: "25" }, "25", -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "50" }, "50", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "100" }, "100", -1)
const _hoisted_58 = [
  _hoisted_54,
  _hoisted_55,
  _hoisted_56,
  _hoisted_57
]
const _hoisted_59 = {
  key: 0,
  class: "p-3"
}
const _hoisted_60 = { class: "col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end" }
const _hoisted_61 = {
  key: 1,
  class: "w-100 mt-5"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "alert alert-warning text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "Data tidak ditemukan !"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "Silahkan lakukan pencarian dengan menggunakan parameter lain")
], -1)
const _hoisted_63 = [
  _hoisted_62
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
            ]),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-solid ps-15",
              placeholder: "Masukkan Kata Kunci",
              style: {"width":"auto"},
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchParam.q) = $event)),
              required: ""
            }, null, 512), [
              [_vModelText, _ctx.searchParam.q]
            ])
          ]),
          _createVNode(_component_el_select, {
            filterable: "",
            clearable: "",
            modelValue: _ctx.searchParam.source,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchParam.source) = $event)),
            placeholder: "Pilih Jenis Media",
            class: "ms-5",
            style: {"width":"auto","min-width":"15%"},
            disabled: "true"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataMedia, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_select, {
            filterable: "",
            clearable: "",
            modelValue: _ctx.searchParam.q_field,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchParam.q_field) = $event)),
            placeholder: "Pilih Field Pencarian",
            class: "ms-5",
            style: {"width":"auto","min-width":"15%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataFieldPencarian, (item) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: item.id,
                  label: item.name,
                  value: item.value
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"]),
          _createVNode(_component_el_form, { class: "me-3" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "filterTanggal",
                class: "ms-5 mb-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    placeholder: "Select a date",
                    name: "filterTanggal",
                    type: "datetimerange",
                    modelValue: _ctx.filterTanggal,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filterTanggal) = $event)),
                    shortcuts: _ctx.filterTanggalShortcut,
                    "start-placeholder": "Tanggal Awal",
                    "end-placeholder": "Tanggal Akhir",
                    "default-time": _ctx.defaultTime
                  }, null, 8, ["modelValue", "shortcuts", "default-time"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.filterTanggal && _ctx.filterTanggal.length > 0 && _ctx.searchParam.q)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-primary ms-2",
                style: {"width":"auto"},
                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.getData()), ["prevent"]))
              }, _hoisted_7))
            : (_openBlock(), _createElementBlock("button", _hoisted_8, _hoisted_10))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (!_ctx.startSearch)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _hoisted_16))
          : (_openBlock(), _createElementBlock("div", _hoisted_17, [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    (_ctx.streamsData.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("p", null, [
                            _hoisted_23,
                            _createElementVNode("b", null, _toDisplayString(_ctx.pagination.total) + " Data", 1),
                            _hoisted_24,
                            _createElementVNode("b", null, _toDisplayString(_ctx.searchParam.q), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.streamsData, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "card shadow mb-3"
                            }, [
                              _createElementVNode("div", _hoisted_25, [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createElementVNode("div", _hoisted_28, [
                                      _createElementVNode("div", _hoisted_29, [
                                        _createElementVNode("div", _hoisted_30, _toDisplayString(item.title), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("div", _hoisted_32, [
                                          _hoisted_33,
                                          _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.setDate(item.date)), 1)
                                        ])
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      (item.source=='media_cetak')
                                        ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                                        : (item.source=='media_tv')
                                          ? (_openBlock(), _createElementBlock("i", _hoisted_37))
                                          : (_openBlock(), _createElementBlock("i", _hoisted_38)),
                                      _createElementVNode("span", _hoisted_39, _toDisplayString(item.portal), 1),
                                      _hoisted_40,
                                      _createElementVNode("span", _hoisted_41, _toDisplayString(item.journalist), 1)
                                    ])
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                (item.content.length > 200)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                                      (!item.show_all)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                            _createElementVNode("span", null, [
                                              _createTextVNode(_toDisplayString(item.content.substring(0, 200)) + "... ", 1),
                                              _createElementVNode("button", {
                                                class: "btn btn-link btn-sm",
                                                onClick: ($event: any) => (item.show_all = true)
                                              }, "Lihat Detail", 8, _hoisted_45)
                                            ])
                                          ]))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                            _createElementVNode("span", null, [
                                              _createTextVNode(_toDisplayString(item.content) + " ", 1),
                                              _createElementVNode("button", {
                                                class: "btn btn-link btn-sm",
                                                onClick: ($event: any) => (item.show_all = false)
                                              }, " Sembunyikan ", 8, _hoisted_47)
                                            ])
                                          ]))
                                    ]))
                                  : (_openBlock(), _createElementBlock("p", _hoisted_48, _toDisplayString(item.content), 1))
                              ]),
                              _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("a", {
                                  href: item.url,
                                  target: "_blank"
                                }, "Lihat Sumber", 8, _hoisted_50)
                              ])
                            ]))
                          }), 128)),
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("div", _hoisted_53, [
                                _createElementVNode("label", null, [
                                  _withDirectives(_createElementVNode("select", {
                                    name: "kt_customers_table_length",
                                    class: "form-select form-select-sm form-select-solid",
                                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchParam.items) = $event)),
                                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.setItemsPerPage && _ctx.setItemsPerPage(...args)))
                                  }, _hoisted_58, 544), [
                                    [_vModelSelect, _ctx.searchParam.items]
                                  ])
                                ])
                              ]),
                              (_ctx.pagination.total > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _createElementVNode("h5", null, "Total : " + _toDisplayString(_ctx.pagination.total), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", _hoisted_60, [
                              _createVNode(_component_el_pagination, {
                                "page-size": _ctx.pagination.limit,
                                "current-page": _ctx.searchParam.page,
                                "onUpdate:current-page": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchParam.page) = $event)),
                                onCurrentChange: _ctx.currentPageChange,
                                layout: "prev, pager, next",
                                total: _ctx.pagination.total,
                                "hide-on-single-page": true,
                                background: ""
                              }, null, 8, ["page-size", "current-page", "onCurrentChange", "total"])
                            ])
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63))
                  ]))
            ]))
      ])
    ])
  ]))
}